import React from 'react'
import PropTypes from 'prop-types'
import LinkButton from './LinkButton'

function GrayLinkButton (props) {
  return (
    <LinkButton classList='vsd-button__outlined vsd-button__extra-small inline-flex justify-center' {...props} />
  )
}

GrayLinkButton.propTypes = {
  href: PropTypes.string,
  content: PropTypes.array,
  dataSource: PropTypes.string,
  trackedEvent: PropTypes.string
}

export default GrayLinkButton
